<template>
    <div class="organization"  >
      <!-- <h1>acquirer</h1> -->

      <v-row no-gutters>

        <v-col cols="auto" class="me-auto" >
          <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
          <v-sheet class="ma-2 pa-2">
            <v-breadcrumbs :items="['Devices0']"></v-breadcrumbs> 
          </v-sheet>        
        </v-col>       
        <v-col cols="auto">
          <v-sheet class="ma-2 pa-2">            
            <v-btn prepend-icon="mdi-plus" color="primary" to="/add-device" >              
              <template v-slot:prepend >
                <v-icon color="white"></v-icon>
                <!-- <router-link to="/add-device" > Add Device </router-link> -->
              </template>
              Add Device
            </v-btn>      
          </v-sheet>
        </v-col>  
      
      </v-row>

      <v-card >
        <v-card-title>
          
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="4">                                 
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field> 
            </v-col>
            <v-col cols="4">
              <v-row justify="center" align="center">
                <v-col cols="auto">
                  <h5>Export : </h5>
                </v-col>
                <v-col cols="auto">
                  <!-- excel-->
                  <download-excel
                    class="btn btn-default"
                    :data="devices"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="filename.xls"
                  >
                    <v-btn density="compact">xls</v-btn>
                  </download-excel>
                </v-col>

                <v-col cols="auto">
                  <!-- cvs -->
                  <download-excel
                    class="btn btn-default"
                    :data="devices"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    type="csv"
                    name="filename.xls"
                  >
                    <v-btn density="compact">csv</v-btn>
                  </download-excel>
                </v-col>

                <v-col cols="auto">
                  
                </v-col>
              </v-row> 
              
              
            </v-col>
          </v-row>          
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="devices"        
          class="elevation-1"
          :search="search"         
          
          
        >  

          <!-- <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search (UPPER CASE ONLY)"
              class="pa-4"
            ></v-text-field>
          </template> -->

        
          <template v-slot:item.tid="{ item }"> 
            
              <p v-for="it in item.raw.merchantDetails" :key="it.id">{{it.tid}}</p>
          </template> 
          
          <template v-slot:item.mid="{ item }">           
              
              <p v-for="it in item.raw.merchantDetails" :key="it.id">{{it.mid}}</p>
          </template> 

          <template v-slot:item.currencyName="{ item }">       
              
              <p v-for="it in item.raw.merchantDetails" :key="it.id">{{it.currency.currencyName}}</p>
          </template> 

          <template v-slot:item.actions="{ item }">              
              <router-link :to="/update-device/+item.raw.id" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"> <v-icon color="green" small class="mr-2" >mdi-pencil</v-icon></router-link>
              
              <v-icon color="red" small @click="compose_delete(item.RAW.Id)" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')">mdi-delete</v-icon>
          </template>
          

        </v-data-table>
      </v-card>

      

      <!-- ADD DIALOG -->
      <!-- <v-dialog
              v-model="dialog"
              persistent
              width="1024"
            >
              
              <v-card>
                <v-card-title>
                  <span class="text-h5">Add Role</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">                                 
                        <v-text-field label="Day name*" required v-model="role_data.f_roleName" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="role_data.f_orgId"
                        ></v-select>                      
                      </v-col>
                      <v-col cols="12">                                 
                        <v-autocomplete
                          :items="permissions"
                          item-title="perName"
                          item-value="perId"
                          label="Select permissions"
                          multiple
                          v-model="role_data.f_perList"
                        ></v-autocomplete>                       
                      </v-col>

                      
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="addRole"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END ADD DIALOG -->

      <!-- UPDATE  DIALOG -->
      <!-- <v-dialog
              v-model="dialog_update"
              persistent
              width="1024"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">Update Day</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">                                 
                        <v-text-field label="Day name*" required v-model="role_data.f_roleName" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="role_data.f_orgId"
                        ></v-select>                      
                      </v-col>
                      <v-col cols="12">                                 
                        <v-autocomplete
                          :items="permissions"
                          item-title="perName"
                          item-value="perId"
                          label="Select permissions"
                          multiple
                          v-model="role_data.f_perList"
                        ></v-autocomplete>                       
                      </v-col>
                      
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_update = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="updateRole"
                  >
                    Update
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END UPDATE  DIALOG -->
      
      <!-- DELETE  DIALOG -->
      <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteRole"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END UPDATE DIALOG -->    


    </div>
  </template>
  
  <script>
  import axios from 'axios'  
  //import JsonExcel from "vue-json-excel3";
  export default {
    name: 'Role',
    props: {
      msg: String ,
      victor : Boolean ,
      ID: String, 
      name: String,   
    },
    data(){
      return {
        //name: '',       
        devices: [],  //used
        organization: [],
        permissions: [], 
        
        
        dialog: false,
        dialog_update: false,
        dialog_delete: false,

        role_data:{  //used
          f_roleName: '',
          f_orgId: '',
          f_perList: [],
          
        },

        deviceId: '',       
        search: '',
        headers: [
        {
            title: 'Device SN',
            align: 'start',
            sortable: false,
            key: 'deviceSN',
          },
          
          { title: 'Merchant Name', key: 'merchant.merchantName' },
          { title: 'Merchant Address', key: 'merchant.merchantAddress' },
          { title: 'TID', key: 'tid' ,sortable: true,},
          { title: 'MID', key: 'mid', sortable: true, },
          { title: 'Currency', key: 'currencyName' },          
          { title: 'Acquirer', key: 'merchant.acquirer.acquirerName' },
          //{ title: 'Date Created', key: 'dateCreated' },
          { title: 'Date Updated', key: 'dateUpdated' },          
          { title: 'Organization', key: 'merchant.acquirer.organization.orgName' },          
          //{ title: 'Actions', key: 'acquirerId', sortable: false },
          { title: 'Actions', key: 'actions', sortable: false },
        ],

        //FOR EXPORT
        json_fields: {
              "Device SN": "deviceSN",
              "Merchant Name": "merchants.merchantName",                          
              "Merchant Address": "merchants.merchantAddress",              
              "TID": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let i = 0;
                        let value1 = '';
                        if(value != null && value.length == 1){
                          value1 = value[i].tid
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].tid +"\n"+value[1].tid
                        // }
                        if(value != null && value.length > 1){
                          for(i=0; i<value.length; i++){
                            //value2 = value[i].tid +" , "+value2 
                            value1 = value[i].tid +"\n"+value1                            
                          }
                        }
                        
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value1}`;

                  },
                    
              },
              "MID": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let u = 0;
                        let value2 = '';
                        if(value != null && value.length == 1){
                          value2 = value[u].mid
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].mid +"\n"+value[1].mid
                        // }
                        if(value != null && value.length > 1){
                          for(u=0; u<value.length; u++){
                            //value2 = value[u].mid +" , "+value2
                            value2 = value[u].mid +"\n"+value2                            
                          }
                        }
                        
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value2}`;

                  },
                    
              },
              "Currency": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let w = 0;
                        let value3 = '';
                        if(value != null && value.length == 1){                          
                          value3 = value[w].currency.currencyName
                          console.log("device_currency", value3)
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].mid +"\n"+value[1].mid
                        // }
                        if(value != null && value.length > 1){
                          for(w=0; w<value.length; w++){
                            //value2 = value[u].currency.currencyName +" , "+value2                                                        
                            value3 = value[w].currency.currencyName +"\n"+value3
                            //console.log("device_currency1", value3)                                                      
                          }
                        }
                        //console.log("device_currency2", value3) 
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value3}`;

                  },
                    
              },
              "Acquirer name": "merchants.acquirer.acquirerName",
              "Created At": "dateCreated",
              "Updated At": "dateUpdated",
              "Organization": "merchants.acquirer.organization.orgName"
        },



        //FOR USER DATA
        user_roles: '',
        user_org: '',
        user_permissions:[],

        //snackbar
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',
        


      }
    },

    created () {
      
    },

    computed: {
      flatItems() {
         return this.devices.reduce(function(acc, v) {
            // console.log("per_object3", [...acc, ...v.merchantDetails])
            return [...acc, ...v.merchantDetails]
            
         }, [])
      },

      
  },

    methods:{

      

      compose_delete(id) {
          this.deviceId = id
          this.dialog_delete = true                   
      },
      
      
      // customSearch (value, search, item) {
      //   console.log("HIII", value)
      //     if (Array.isArray(value)) {
      //         return value.some(item=>Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search)))
      //     }
      //     return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      // },

      customSearch (value, query) {  //TESTING IT
        // console.log("HIII", value)
        // console.log("HAA", query)
        return value != null &&
          query != null &&
          typeof value === 'string' &&
          //value.toString().toLocaleUpperCase().indexOf(query) !== -1
          value.toString().toLocaleLowerCase().indexOf(query) !== -1
      },

      // customSearch (value, query) {
      //   console.log("HIII", value)
      //   console.log("HAA", query)
      //   return value != null &&
      //     query != null &&
      //     typeof value === 'string' &&          
      //     value.toString().toLocaleLowerCase().indexOf(query) !== -1
          
      // },

      // customSearch (value, search, items) {
      //   console.log("HIII", value)
      //     if (Array.isArray(value)) {
      //         return value.some(item=>Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search)))          
      //       }

      //       console.log("HIIkk", Object.values(items))            
           
      //     return Object.values(items).some(v=>v&&v.toString().toLowerCase().includes(search))        

         

      // },

      // customSearch (value, search, item) {      
      //   return Object.values(item).some(prop => {
      //     return String(prop).includes(search)
      //   })
      // },

      // customSearch(value, search, item) {
      //   console.log("HIII", value +"/"+ search +"/"+ item)
      //   console.log("HIIIppoo", Object.values(item) )
      //   console.log("HIIIpp", Object.values(item).some((v) => v && v.toString().toLowerCase().includes(search)) )
      //   // return Object.values(item).some(
      //   //     (v) => v && v.toString().toLowerCase().includes(search)
      //   // );
      //   return Object.values(item);
      // },

      // customSearch(value, search, item) {
      //   return Object.values(item).some(
      //     (v) => {
      //       if (typeof (v) === 'object') {
      //         return v.some(v1 => {
      //           return Object.values(v1).some(
      //             (v2) => {
      //               return v2 && v2.toString().includes(search)
      //             }
      //           )
      //         });
      //       } else {
      //         return v && v.toString().includes(search);                         
      //       }
      //     }
      //   );
      // },

      //How to apply Vuetify search in datatable when column data is also an array

      // customSearch (value, search) {
      //     // console.log("HIII", value +"/"+item+"/"+search)
      //     // if (Array.isArray(value)) {
      //     //     return value.some(item=>Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search)))
      //     // }
      //     // console.log("HOOO",  Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search)))
      //     // return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      //     console.log("HOOO",  value.toString().toLocaleUpperCase().indexOf(search))
      //     console.log("HAAA",  value.toString().toLocaleUpperCase())
      //     return value != null &&
      //     search != null &&
      //     typeof value === 'string' &&
      //     value.toString().toLocaleUpperCase().indexOf(search) !== -1

      // },

      

      async deleteRole() {
          this.dialog_delete = false 
          try{         
            let result = await axios.delete(window.baseurl+""+"device/delete/" +""+this.deviceId ,
                 {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                  );          
            if (result.status == 200) {
                //alert("successfull deleted"); 
                this.show_toast(true, "success", "Deleted");
                window.setInterval(() => {
                      this.$router.go();
                }, 7000)
                //this.$router.go();             
            }
          }
          catch (error){            
            this.show_toast(true, "warning", error.message);
          }
      },
      
    },
    //get list of acquirers
    async mounted(){
      
      this.checkTokenExpiry();      


      //get device list
      
      let result;
      try{

        //if(this.global_permissions.includes("DEVICE_VIEW")){
         
            result = await axios.get(window.baseurl + "devices/org/" + this.$route.params.id , {
              "headers": {'Authorization': 'Bearer ' + this.accessToken} 
            });
          
          // console.log("devices2_object", result);
          this.devices = result.data.records; 
       // }

        
      } 
      catch (error){            
          this.show_toast(true, "warning", error.message);
      }

    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  </style>
  